// extracted by mini-css-extract-plugin
export var centerSearchBar = "PreHeader-module--centerSearchBar--db863";
export var color_black = "PreHeader-module--color_black--40d93";
export var color_white = "PreHeader-module--color_white--68789";
export var searchBar = "PreHeader-module--searchBar--178f8";